module.exports = __webpack_public_path__ + "files/2f5e34b51cc6e3401769ae7cc30d2b27.png";